<div [formGroup]="gatewayForm" class="dark:bg-black p-6">
  <h3 class="pb-2 text-primary text-l font-bold">{{dialogType | titlecase}} Gateway</h3>
  <p>All fields are required</p>
  <fieldset class="fieldset mt-2">
    <legend class="fieldset-legend">Gateway ID</legend>
    <input type="text" class="input dark:text-white" formControlName="gateway_id" />
    @if (gatewayForm.controls.gateway_id.invalid && gatewayForm.controls.gateway_id.touched) {
      @for (error of gatewayForm.controls.gateway_id.errors | keyvalue; track error.key) {
        <div class="text-red-500 text-xs">
          @switch (error.key) {
            @case ('required') { ID is required }
            @case ('minlength') { Your input is too short, must be 16 characters }
            @case ('maxlength') { Your input is too long, must be 16 characters }
            @case ('pattern') { Only hexidecimal characters are allowed }
          }
        </div>
      }
    } @else {
      <p class="label">Format: 16 characters hexidecimal</p>
    }
  </fieldset>

  <fieldset class="fieldset mt-4">
    <legend class="fieldset-legend">Mode</legend>
    <select class="select" formControlName="mode" >
      <option value="idle">Idle</option>
      <option value="continuous">Continuous</option>
    </select>
  </fieldset>

  <fieldset class="fieldset mt-4">
    <legend class="fieldset-legend">Mode</legend>
    <select class="select" formControlName="power" >
      <option value="low">Low</option>
      <option value="high">High</option>
    </select>
  </fieldset>
  <fieldset class="fieldset mt-4">
    <legend class="fieldset-legend">Country code</legend>
    <input type="text" class="input dark:text-white" formControlName="country_code" />
  </fieldset>
  <div class="mt-8">
    <button (click)="confirmDevice()"
            [mat-dialog-close]="dialogData" [disabled]="!gatewayForm.valid" class="btn btn-primary mr-4"> {{dialogType | titlecase}} Gateway</button>
    <button (click)="cancelDevice()" class="btn">Cancel</button>
  </div>
</div>
